import React, { useState, useRef, useEffect } from "react";
import { Link,useLocation, useNavigate,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";

import axios from "axios";

import swal from 'sweetalert';

import Goodbtn from "../assets/good_btn.png";
import Normalbtn from "../assets/normal_btn.png";
import Badbtn from "../assets/bad_btn.png";

import SpinIcon from '../assets/spin_stress.gif';

import { Get, GetList, GetTime, GetHrv, GetDiabetesRisk,GetHypertensionRisk, UpdateKiosk } from "../lib/DeviceData";
import moment from 'moment';

import ttsAudio from "../assets/sound/tts_08.mp3"; // mp3 경로 import
import ttsAudio_en from "../assets/sound/en/8.mp3";
import ttsAudio_jp from "../assets/sound/jp/8.mp3";
import ttsAudio_cn from "../assets/sound/cn/8.mp3";
import ttsAudio_mn from "../assets/sound/mn/9.mp3";


const Readys = () => {
    const { t,i18n } = useTranslation();

    const location = useLocation();
    const userInfo = { ...location.state };
    const navigate = useNavigate();

    const audioRef = useRef(null);

    const LIGHT_API = "http://127.0.0.1:18790";

    
    const [result_data, setDatas] = useState([]);

    const [hrv_data, setHrv] = useState([]);

    const [bucketTime, setbucketTime] = useState([]);
    const [HrTime, sethrTime] = useState([]);
    const [RrTime, setrrTime] = useState([]);
    const [ApneaTime, setapneaTime] = useState([]);
    const [MotionTime, setmotionTime] = useState([]);
    const [FsrTime, setfsrTime] = useState([]);

    const [device_sn, SetDevice_sn] = useState(0);
    const [device_no, SetDevice_no] = useState(0);
    const [member_no, SetMemeber_no] = useState(0);
    const [name, SetName] = useState('');
    const [sex, SetSex] = useState(0);
    const [birth, SetBirth] = useState(0);
    const [feel, SetFeel] = useState(0);
    const [height, SetHeight] = useState(0);
    const [weight, SetWeight] = useState(0);
    const [closestHRVData, setClosestHRVData] = useState(null);
    const [dbok, setdbok] = useState(0);

    const [diabetesRisk, setDiabetesRisk] = useState(null);
    const [hypertensionRisk, setHypertensionRisk] = useState(null);

    const toNum = (v) => {
    const n = Number(v);
        return Number.isFinite(n) ? n : null;
    };

    const avg = (arr) => {
    const v = arr.filter((x) => x != null);
    if (v.length === 0) return null;
        return v.reduce((a, b) => a + b, 0) / v.length;
    };


    const [Kiosk, setKiosk] = useState({
          device_sn: "",          // string
            device_no: 0,           // number
            member_no: 0,           // number
            name: "",               // string
            sex: 0,               // number
            birth: "",              // string, ex: '19950409'
            feel: 0,                // number
            heart_avg: 0,           // number
            resp_avg: 0,            // number
            RMSSD: 0,               // number (대문자 주의)
            SDNN: 0,                // number
            pNN50: 0,               // number
            baevsky_si: 0,          // number
            result_data:null,
    });

 


    useEffect(() => {
        const data = userInfo;

        const device_sn=data.device_sn;
        const device_no=data.device_no;
        const member_no=data.member_no;
        const name=data.name;
        const sex=data.sex;
        const birth=data.birth;
        const feel = data.feel;
        const height = data.height;
        const weight = data.weight;

        const startTime = data.start;
        const endTime = data.end;


        if(device_no && endTime){
            GetTime(device_no,startTime,endTime, res => {
                setDatas(res);
            });

            GetHrv(device_no, res => {
                setHrv(res);
            });

            GetDiabetesRisk(device_no, startTime, endTime, res => {
                setDiabetesRisk(res);
            });

            GetHypertensionRisk(device_no, startTime, endTime, res => {
                setHypertensionRisk(res);
            });

        }
    }, []);

    useEffect(() => {
        if (result_data.rows) {
            var array_bucket = [];
            var array_hr = [];
            var array_rr = [];
            var array_apnea = [];
            var array_motion = [];
            var array_fsr = [];

            result_data.rows.forEach(item => {
                array_bucket.push(moment(item.bucket).format("YYYY-MM-DD HH:mm:ss"));
                array_hr.push(item.hr);
                array_rr.push(item.rr);
                array_fsr.push(item.fsr);
                if (item.motion != "-") {
                    array_motion.push(item.hr);
                } else {
                    array_motion.push("");
                }
                if (item.apnea != "-") {
                    array_apnea.push(item.rr);
                } else {
                    array_apnea.push("");
                }
            });

            setbucketTime(array_bucket[0]);
            sethrTime(array_hr[0]);
            setrrTime(array_rr[0]);

            // 고정 초록
            axios.post(`${LIGHT_API}/light/solid`, { color: "green", level: 200 }, { timeout: 600 }).catch(() => {});

            const data = userInfo;

            SetDevice_sn(data.device_sn);
            SetDevice_no(data.device_no);
            SetMemeber_no(data.member_no);
            SetName(data.name);
            SetSex(data.sex);
            SetBirth(data.birth);
            SetFeel(data.feel);
            SetHeight(data.height);
            SetWeight(data.weight);
        }     


    },[result_data.rows]);

    useEffect(() => {
        if (!hrv_data?.rows || hrv_data.rows.length === 0) return;

        // ✅ 최근 6개 row에서 bcg_results를 전부 펼침
        const allBcg = [];
        for (const row of hrv_data.rows) {
            const bcg = row?.data?.bcg_results;
            if (Array.isArray(bcg)) allBcg.push(...bcg);
        }

        if (allBcg.length === 0) return;

        // ✅ rmssd != 0 인 것만 필터링
        const valid = allBcg.filter((x) => {
            const rm = toNum(x?.hrv_analysis_data?.rmssd);
            return rm != null && rm > 0;
        });

        if (valid.length === 0) return;

        // ✅ 평균 HR(선택): heart_rate가 있으면 그 평균을 target으로 사용
        const avgHr = avg(valid.map((x) => toNum(x?.heart_rate)));

        // ✅ targetHeartRate 결정
        // 1) 평균 HR이 있으면 그걸 사용
        // 2) 없으면 기존처럼 최신 row의 heart_rate 사용
        const fallbackTarget = toNum(hrv_data.rows[0]?.data?.heart_rate);
        const targetHeartRate = avgHr ?? fallbackTarget ?? toNum(valid[0]?.heart_rate) ?? 0;

        // ✅ target에 가장 가까운 bcg_result 하나 선택
        const closest = valid.reduce((prev, curr) => {
            const ph = toNum(prev?.heart_rate) ?? 0;
            const ch = toNum(curr?.heart_rate) ?? 0;
            return Math.abs(ch - targetHeartRate) < Math.abs(ph - targetHeartRate) ? curr : prev;
        });

        // ✅ 평균 HRV 지표 생성 (rmssd!=0인 것들 기준)
        const rmssdAvg = avg(valid.map((x) => toNum(x?.hrv_analysis_data?.rmssd)));
        const sdnnAvg  = avg(valid.map((x) => toNum(x?.hrv_analysis_data?.sdnn)));
        const pnn50Avg = avg(valid.map((x) => toNum(x?.hrv_analysis_data?.pnn50)));
        const baiAvg   = avg(valid.map((x) => toNum(x?.hrv_analysis_data?.baevsky_si)));

        // ✅ 프론트에서 쓰기 좋게 closestHRVData 형태로 맞춤
        setClosestHRVData({
            // 평균값(원하신 핵심)
            rmssd: rmssdAvg != null ? Number(rmssdAvg.toFixed(2)) : null,
            sdnn:  sdnnAvg  != null ? Number(sdnnAvg.toFixed(2))  : null,
            pnn50: pnn50Avg != null ? Number(pnn50Avg.toFixed(2)) : null,
            baevsky_si: baiAvg != null ? Number(baiAvg.toFixed(2)) : null,

            // 디버깅/검증용(원치 않으면 제거 가능)
            _sample_count: valid.length,
            _target_hr: targetHeartRate,
            _closest_hr: toNum(closest?.heart_rate),
        });
        }, [hrv_data]);


    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    const calcBMI = (heightCm, weightKg) => {
        if (!heightCm || !weightKg) return null;

        const h = Number(heightCm) / 100; // cm → m
        const w = Number(weightKg);

        if (h <= 0 || w <= 0) return null;

        return Number((w / (h * h)).toFixed(1)); // 소수 1자리
    };

    const bmiLevel = (bmi) => {
        if (bmi == null) return null;

        if (bmi < 16.0) return "고도 저체중";
        if (bmi < 18.5) return "저체중";

        if (bmi < 20.0) return "저체중 경계";
        if (bmi < 23.0) return "정상";

        if (bmi < 25.0) return "과체중";

        if (bmi < 30.0) return "비만 1단계";
        if (bmi < 35.0) return "비만 2단계";
        return "비만 3단계";
    };

    const clickResult= () => {
        const rmssd = Number(closestHRVData?.rmssd ?? 0);
        const pnn50 = Number(closestHRVData?.pnn50 ?? 0);
        const sdnn  = Number(closestHRVData?.sdnn ?? 0) + 20;
        const baevsky_si = Number(closestHRVData?.baevsky_si ?? 0);

        const bmi = calcBMI(height, weight); 
        const bmi_text = bmiLevel(bmi);

        const jsonString = {
            height: height,
            weight: weight,
            bmi: bmi,
            bmi_text: bmi_text,
            diabetes_risk: diabetesRisk
        };

        Kiosk.device_sn=device_sn;
        Kiosk.device_no=Number(device_no);
        Kiosk.member_no=Number(member_no);
        Kiosk.name=name;
        Kiosk.sex=Number(sex);
        Kiosk.birth=birth;
        Kiosk.feel=Number(feel);
        Kiosk.heart_avg=Number(HrTime);
        Kiosk.resp_avg=Number(RrTime);
        Kiosk.rmssd=Number(rmssd);
        Kiosk.sdnn=Number(sdnn);
        Kiosk.pnn50=Number(pnn50);
        Kiosk.baevsky_si=Number(baevsky_si);
        Kiosk.result_data=JSON.stringify(jsonString);
        Kiosk.date=moment().format('YYYY-MM-DD HH:mm:ss');
        
        setKiosk(Kiosk);

  

        UpdateKiosk(Kiosk, res => {
             setdbok(res);
        });


        navigate("/result", {
            state: {
                device_sn: `${device_sn}`,
                device_no: `${device_no}`,
                member_no: `${member_no}`,
                name: `${name}`,
                sex: `${sex}`,
                birth: `${birth}`,
                feel: `${feel}`,
                date: `${bucketTime}`,
                hr: `${HrTime}`,
                rr: `${RrTime}`,
                sdnn: `${sdnn}`,
                rmssd: `${rmssd}`,
                pnn50: `${pnn50}`,
                baevsky_si: `${baevsky_si}`,
                diabetes_score: diabetesRisk?.score ?? 0,
                diabetes_label: diabetesRisk?.label ?? "낮음",
                hypertension_score: hypertensionRisk?.score ?? 0,
                hypertension_label: hypertensionRisk?.label ?? "낮음",
                result_data: JSON.stringify(jsonString)
            }
        });
    }

    var lng=i18n.language;

    return (
        <main className="main-container">
            {lng == "ko" && <audio ref={audioRef} src={ttsAudio} autoPlay />}
            {lng == "en" && <audio ref={audioRef} src={ttsAudio_en} autoPlay />}
            {lng == "jp" && <audio ref={audioRef} src={ttsAudio_jp} autoPlay />}
            {lng == "cn" && <audio ref={audioRef} src={ttsAudio_cn} autoPlay />}
            {lng == "mn" && <audio ref={audioRef} src={ttsAudio_mn} autoPlay />}

            <div className="Top_loading">
                <h2>
                    {t("측정이 완료되었습니다.")}
                    <br />
                    {t("아래버튼을 눌러")}
                    <br />
                    {t("결과를 확인해보세요.")}
                </h2>
                <div className="start-btn-area">
                    <button className="Start" onClick={() => clickResult()}>
                        {t("결과보기")}
                    </button>
                </div>
            </div>
        </main>
    );
};

export default Readys;
